import { useContext } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Chip from "@mui/material/Chip";
import { Context } from "../context/FittingContext";

const StatusBar = ({ stepPosition }) => {
	const { clubState } = useContext(Context);
	const clubType = localStorage.getItem("clubType") || "Drivers";
	const clubSubType = localStorage.getItem("clubSubType") || "";
	const showBallSelection = (clubType === "Drivers" || clubType === "Irons") && clubState.selectedBall;

	// Determine chip colors based on step position
	// Green if we've advanced past that step, blue otherwise
	const shaftChipStyle = clubState.selectedShaft ? (stepPosition > 1 ? {
		backgroundColor: "rgba(76, 175, 80, 0.15)",
		border: "1px solid rgba(76, 175, 80, 0.6)",
		"& .MuiChip-label": { color: "#4caf50" }
	} : {
		backgroundColor: "rgba(25, 118, 210, 0.15)",
		border: "1px solid rgba(25, 118, 210, 0.5)",
		"& .MuiChip-label": { color: "#1976d2" }
	}) : {};

	const headChipStyle = clubState.selectedHead ? (stepPosition > 2 ? {
		backgroundColor: "rgba(76, 175, 80, 0.15)",
		border: "1px solid rgba(76, 175, 80, 0.6)",
		"& .MuiChip-label": { color: "#4caf50" }
	} : {
		backgroundColor: "rgba(25, 118, 210, 0.15)",
		border: "1px solid rgba(25, 118, 210, 0.5)",
		"& .MuiChip-label": { color: "#1976d2" }
	}) : {};

	const ballChipStyle = stepPosition > 3 ? {
		backgroundColor: "rgba(76, 175, 80, 0.15)",
		border: "1px solid rgba(76, 175, 80, 0.6)",
		"& .MuiChip-label": { color: "#4caf50" }
	} : {
		backgroundColor: "rgba(25, 118, 210, 0.15)",
		border: "1px solid rgba(25, 118, 210, 0.5)",
		"& .MuiChip-label": { color: "#1976d2" }
	};

	return (
		<Paper
			elevation={2}
			sx={{
				padding: 2,
				backgroundColor: "#f5f5f5",
				display: "flex",
				alignItems: "center",
				gap: 3,
			}}
		>
			<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
				<Typography variant="body2" sx={{ fontWeight: "bold", color: "#666", whiteSpace: "nowrap" }}>
					Club Type:
				</Typography>
				<Typography variant="body1" sx={{ fontWeight: "bold", color: "#1976d2" }}>
					{clubType}{clubSubType ? ` (${clubSubType})` : ""}
				</Typography>
			</Box>

			<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
				<Typography variant="body2" sx={{ fontWeight: "bold", color: "#666", whiteSpace: "nowrap" }}>
					Selected Shaft:
				</Typography>
				<Chip
					label={clubState.selectedShaft?.name || "None"}
					color={clubState.selectedShaft ? "primary" : "default"}
					size="small"
					sx={shaftChipStyle}
				/>
			</Box>

			<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
				<Typography variant="body2" sx={{ fontWeight: "bold", color: "#666", whiteSpace: "nowrap" }}>
					Selected Head:
				</Typography>
				<Chip
					label={clubState.selectedHead?.name || "None"}
					color={clubState.selectedHead ? "primary" : "default"}
					size="small"
					sx={headChipStyle}
				/>
			</Box>

			{showBallSelection && (
				<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
					<Typography variant="body2" sx={{ fontWeight: "bold", color: "#666", whiteSpace: "nowrap" }}>
						Selected Ball:
					</Typography>
					<Chip
						label={clubState.selectedBall.name}
						color="primary"
						size="small"
						sx={{
							...ballChipStyle,
							maxWidth: "200px",
							"& .MuiChip-label": {
								...ballChipStyle["& .MuiChip-label"],
								overflow: "hidden",
								textOverflow: "ellipsis",
								whiteSpace: "nowrap"
							}
						}}
					/>
				</Box>
			)}
		</Paper>
	);
};

export default StatusBar;
